import classNames from "classnames";
import { useMemo, useRef } from "react";
import AscTag from "../../AscTag/AscTag";
import AscTextInput, { AscTextInputProps } from "../AscTextInput/AscTextInput";
import styles from "./AscActivityInput.module.scss";

export interface AscActivityInputProps extends Omit<AscTextInputProps, "ref"> {
  correct?: boolean;
  ref?: React.Ref<HTMLInputElement>;
}

export default function AscActivityInput({
  correct,
  ...rest
}: AscActivityInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const suffixComponent = useMemo(() => {
    if (correct === true) {
      return <AscTag className={styles.tag} type="correct" label="correct" />;
    }
    if (correct === false) {
      return (
        <AscTag className={styles.tag} type="incorrect" label="incorrect" />
      );
    }
    return null;
  }, [correct]);

  return (
    <AscTextInput
      className={classNames(styles.ground, {
        [styles.noLabel]: correct !== undefined,
      })}
      innerInputClassName={styles.innerInputClassName}
      suffixComponent={suffixComponent}
      {...rest}
      ref={inputRef}
    />
  );
}
